import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { DeezerKind, deezerPageUrl } from './deezer-links';

/** Small, quiet icon button that opens a song or album on deezer.com in a new tab. */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-deezer-link',
  imports: [MatIcon],
  template: `
    @if (href(); as url) {
    <a class="deezer-link" [href]="url" target="_blank" rel="noopener noreferrer"
      [attr.aria-label]="'Open ' + label() + ' on Deezer'" [title]="'Open ' + label() + ' on Deezer'"
      (click)="$event.stopPropagation()">
      <mat-icon>open_in_new</mat-icon>
    </a>
    }
  `,
  styles: [`
    :host { display: inline-flex; }
    .deezer-link { display: inline-flex; align-items: center; justify-content: center; padding: 4px; border-radius: 50%;
      color: #888; line-height: 0; text-decoration: none; }
    .deezer-link:hover { background: rgba(103, 58, 183, 0.1); color: #673ab7; }
    .deezer-link mat-icon { font-size: 18px; width: 18px; height: 18px; }
  `]
})
export class DeezerLinkComponent {
  kind = input.required<DeezerKind>();
  id = input.required<string | number>();
  /** Used in the accessible label, e.g. the song title. */
  name = input('');

  href = computed(() => deezerPageUrl(this.kind(), this.id()));
  label = computed(() => this.name() ? `“${this.name()}”` : this.kind());
}
